import * as React from 'react';
import { Translate, I18n } from 'react-redux-i18n';

import Popup from '../../../Popup';
import { PopupBody, Input, InputLabel, PopupLoader } from '../../styles';
import { Spinner } from '../../../Spinner/styles';

interface SalesforcePopupProps {
	isDisplayed: boolean;
	onCancel: () => void;
	onConfirm: (clientId: string, clientSecret: string) => void;
	isLoading: boolean;
	clientId?: string;
	clientSecret?: string;
}

interface SalesforcePopupState {
	clientId: string;
	clientSecret: string;
}

const SalesforcePopup = ({
	isDisplayed,
	onCancel,
	onConfirm,
	isLoading,
	clientId: initialClientId,
	clientSecret: initialClientSecret,
}: SalesforcePopupProps) => {
	const initialState: SalesforcePopupState = {
		clientId: initialClientId || '',
		clientSecret: initialClientSecret || '',
	};
	const [state, setState] = React.useState<SalesforcePopupState>(initialState);

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setState(state => ({
			...state,
			[name]: value,
		}));
	};

	const isError = (): boolean => !(state.clientId && state.clientSecret);

	React.useEffect(() => {
		const { clientId, clientSecret } = state;
		if (initialClientId !== clientId || initialClientSecret !== clientSecret) {
			setState(state => ({
				...state,
				clientId: initialClientId || '',
				clientSecret: initialClientSecret || '',
			}));
		}
	}, [initialClientId, initialClientSecret, isDisplayed]);

	const { clientId, clientSecret } = state;

	return (
		<Popup
			isDisplayed={isDisplayed}
			label={I18n.t('messages.salesforce_activation')}
			onCancel={onCancel}
			onConfirm={() => onConfirm(clientId, clientSecret)}
			isConfirmDisabled={isError() || isLoading}
		>
			<PopupBody>
				{isLoading && <PopupLoader><Spinner /></PopupLoader>}
				<InputLabel>
					<Translate value="messages.client_id" />
					<Input
						type="text"
						name="clientId"
						value={clientId}
						isError={!clientId}
						onChange={handleInputChange}
					/>
				</InputLabel>
				<InputLabel>
					<Translate value="messages.client_secret" />
					<Input
						type="text"
						name="clientSecret"
						value={clientSecret}
						isError={!clientSecret}
						onChange={handleInputChange}
					/>
				</InputLabel>
			</PopupBody>
		</Popup>
	);
};

export default SalesforcePopup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProfilePage/CRMSelector/SalesforcePopup/index.tsx